<template>
    <SideFormSection :showDivider="true">
        <template #title> Change your password </template>
        <template #rawContent>
            <Card
                title="Reset Password"
                iconName="locker"
            >
                <template #content>
                    <ApiForm
                        :url="RoutePathAppEnum.MyProfile_UpdatePassword"
                        method="POST"
                        ref="apiFormRef"
                    >
                        <div :key="formKey">
                            <FormControl
                                required
                                label="Current password"
                                :error="
                                    apiFormRef?.response?.getValidationError(
                                        RequestBodyKeyEnum.App_UpdatePassword_CurrentPassword,
                                    )
                                "
                            >
                                <TextInput
                                    type="password"
                                    :name="
                                        RequestBodyKeyEnum.App_UpdatePassword_CurrentPassword
                                    "
                                    required
                                />
                            </FormControl>

                            <FormControl
                                required
                                label="New password"
                                :error="
                                    apiFormRef?.response?.getValidationError(
                                        RequestBodyKeyEnum.App_UpdatePassword_NewPassword,
                                    )
                                "
                            >
                                <TextInput
                                    type="password"
                                    :name="
                                        RequestBodyKeyEnum.App_UpdatePassword_NewPassword
                                    "
                                    required
                                />
                            </FormControl>

                            <FormControl
                                required
                                label="New password confirmation"
                                :error="
                                    apiFormRef?.response?.getValidationError(
                                        RequestBodyKeyEnum.App_UpdatePassword_NewPasswordConfirmation,
                                    )
                                "
                            >
                                <TextInput
                                    type="password"
                                    :name="
                                        RequestBodyKeyEnum.App_UpdatePassword_NewPasswordConfirmation
                                    "
                                    required
                                />
                            </FormControl>
                        </div>
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    const apiFormRef = ref<ApiFormRefType>(null)
    const formKey = ref<number>(0)

    const submit = () => {
        apiFormRef.value?.submit()?.then(() => {
            formKey.value += 1
        })
    }
</script>
